import { cardKey } from './';
import { cardHeaderKey } from './card-header';
import { cardSectionKey } from './card-section';
export var createCardDriver = function (wrapper) {
    var base = wrapper.$("." + cardKey);
    return {
        header: function () { return base.$("." + cardHeaderKey); },
        section: function (idx) {
            if (idx === void 0) { idx = 0; }
            return base.$$("." + cardSectionKey).get(idx);
        },
        base: base,
    };
};
//# sourceMappingURL=driver.js.map